import { render, staticRenderFns } from "./ActsHome.vue?vue&type=template&id=29bbe50b&scoped=true&"
import script from "./ActsHome.vue?vue&type=script&lang=js&"
export * from "./ActsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbe50b",
  null
  
)

export default component.exports